import { Injectable } from "@angular/core";
import { OperationResponse } from "@app/common/models/operation-response";
import { ServiceBase } from "@app/core/service-base";
import { Observable } from "rxjs";
import { CourseLogo } from "../models/course-logo";

@Injectable({
  providedIn: 'root'
})
export class CourseLogosService extends ServiceBase {
  getCourseLogo(courseCode: string, courseLogoType: number) : Observable<OperationResponse<CourseLogo>>{
    return this.getObjectFromRemoteStoreOnly<CourseLogo>(`courses/${courseCode}/logo?logotype=${courseLogoType}`);
  }

  getCourseLogoAccess(courseCode: string) : Observable<OperationResponse<CourseLogo>> {
    return this.getObjectFromRemoteStoreOnly(`courses/${courseCode}/logo/access`);
  }

  setCourseLogo(courseCode: string, courseLogo: CourseLogo) : Observable<OperationResponse<CourseLogo>>{
    return this.setObjectInAvailableStores(courseLogo, `courses/${courseCode}/logo`, false);
  }

  updateCourseLogo(courseCode: string, id: string, courseLogo: CourseLogo) : Observable<OperationResponse<CourseLogo>>{
    return this.setObjectInAvailableStores(courseLogo, `courses/${courseCode}/logo/${id}`, false);
  }

  deleteCourseLogo(courseCode: string, id: string) : Observable<OperationResponse<CourseLogo>>{
    return this.deleteObjectFromAvailableStores<CourseLogo>(`courses/${courseCode}/logo/${id}`, false);
  }
}